import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { Icon } from '@nazka/nazka.mapframe.components';
import { faCheck } from '@fortawesome/pro-light-svg-icons';

import { useTranslation } from '@utils/i18n/i18n.consumers';

import './session-selector-button.styl';

function SessionSelectorButton({ session, completed = false }) {
  const navigate = useNavigate()
  const location = useLocation()

  const { t } = useTranslation();

  return (
    <button
      key={session.id}
      className={completed ? 'session-selector-button__module session-selector-button__module--completed' : 'session-selector-button__module'}
      type="button"
      onClick={() => navigate(`${location.pathname}/session/${session.id}/part/${session.parts[0].id}`)}
    >
      {session.icon && <img className="session-selector-button__img" src={session.icon} alt={session.title} />}
      <h4 className="session-selector-button__item-title">{t(session.title)}</h4>
      {session.description && <p className="session-selector-button__description">{t(session.description)}</p>}
      <div className={completed ? 'session-selector-button__btn-wrapper session-selector-button__btn-wrapper--completed' : 'session-selector-button__btn-wrapper'}>
        {completed && <Icon icon={faCheck} size="16px" className="session-selector-button__icon" />}
      </div>
    </button>
  )
}

export default SessionSelectorButton